/* Notes

- canOverwrite method to check whether the current page can be overwritten
  by cached content?

- Need a "sanity check" value which can be compared to see if the cached
  content matches. Default could be length of html, or don't use by default.
  For cag it's the href of the next link as this contains the order_token

- use #fragment to remember which page we're at, might solve above problems

*/

(function (window, factory) {
  // universal module definition - thanks @desandro
  /* eslint-disable eqeqeq, no-undef */
  if (typeof define == 'function' && define.amd) {
    // AMD
    define(['jquery'], factory);
  } else if (typeof module == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(require('jquery'));
  } else {
    // browser global
    window.InfScr = factory(window.jQuery);
  }
  /* eslint-enable eqeqeq, no-undef */
}(window, function factory ($) {
  'use strict';

  function InfScr (container, options) {
    /* Create an infinite-scrolling page from a container with pagination.

       Options:

       nextSelector: css selector to find the "next page" link
       contentSelector: selector to find content
       autoOffset: distance from bottom to trigger auto-load
       callback: function called on content load
       bind: whether to bind the resize/scroll handlers directly to the window
       get_url: function to get the next page url from a link

       If bind is false, the resize method must be called before the
       auto-load behaviour will work. */
    var containerSelector = container;
    container = $(container);

    options = $.extend({
      nextSelector: null,
      contentSelector: null,
      autoOffset: null,
      bind: false,
      allowCache: true,
      get_url: function (link) {
        return link.attr('href');
      },
      get_content: function (data) {
        return data;
      },
      getCacheKey: function () {
        // TODO get a unique key for the instance/url etc
        return 'infscr_cache' + window.location.pathname + window.location.search;
        // return 'infscr_cache-' + containerSelector.substr(1);
      },
      beforeLoad: null,
      onLoad: null
    }, options);
    var loading = false;
    var winHeight;
    var containerOffset;
    var autoLoadThreshold;
    var setThreshold;
    var xhr;

    if (options.allowCache) {
      var cached = window.sessionStorage.getItem(options.getCacheKey());
      // TODO reenable cached con
      // var cached = false;
      if (cached) {
        // assume cached is a superset of the current items. TODO check this is
        // actually the case
        // console.log('Adding', container.html().length, cached.length);

        var tempEl = $('<div>').html(cached);
        var currentItems = container.find(options.contentSelector);
        var newItems = tempEl.find(options.contentSelector)
           .slice(currentItems.length);
        container.html(tempEl.html());
        options.onLoad(newItems, container);
      } else {
        window.sessionStorage.setItem(options.getCacheKey(), container.html());
      }
    }

    function cancelXhr () {
      if (xhr) {
        xhr.abort();
      }
    }

    function append (url) {
      if (!loading) {
        container.addClass('loading-more');
        loading = true;
        cancelXhr();
        if (options.beforeLoad) {
          options.beforeLoad();
        }
        // TODO get rid of jquery, use window.fetch
        xhr = $.get(url, function (data) {
          var html = options.get_content(data);
          var content = $('<div>').html(html);
          var nextLink = content.find(options.nextSelector);
          var link = container.find(options.nextSelector);
          var newContent = content.find(options.contentSelector);

          link.addClass('disabled');
          container.append(newContent);
          container.append(nextLink);
          // change link var to new
          link = nextLink;

          container.removeClass('loading-more');
          if (options.allowCache) {
            window.sessionStorage.setItem(options.getCacheKey(), container.html());
          }
          if (options.onLoad) {
            options.onLoad(newContent, container);
          }
          loading = false;
          if (setThreshold) {
            // won't exist if not auto-loading
            setThreshold();
          }
        });
      }
    }

    container.on('click', options.nextSelector + ':not(.disabled)', function () {
      append(options.get_url($(this)));
      return false;
    });

    var obj = {
      cancel: cancelXhr
    };

    function resize (w, h) {
      winHeight = h;
      containerOffset = container.offset();
      setThreshold();
    }

    function scroll (t, l) {
      if (t > autoLoadThreshold) {
        container.find(options.nextSelector + ':not(.disabled)').trigger('click');
      }
    }

    if (options.autoOffset) {
      // container.find(options.nextSelector).hide();

      setThreshold = function () {
        if (winHeight === undefined) {
          return;
        }
        if (containerOffset) {
          autoLoadThreshold = containerOffset.top + container.outerHeight() -
          winHeight - options.autoOffset;
        } else {
          autoLoadThreshold = 0 + container.outerHeight() -
          winHeight - options.autoOffset;
        }
      };

      // if (options.bind) {
      //   bind_handlers(resize, scroll);
      // }
      obj.resize = resize;
      obj.setThreshold = setThreshold;
      obj.scroll = scroll;
    }
    return obj;
  }

  return InfScr;
}));



// WEBPACK FOOTER //
// ./assets/j/util/infscr.js